export function sleep(second = 2) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), second * 1000)
  })
}
